import { useState, useEffect } from 'react'

interface QuoteTimerProps {
  expiresAt: Date | string
  className?: string
  onExpired?: () => void
}

const QuoteTimer = ({
  expiresAt,
  className = '',
  onExpired,
}: QuoteTimerProps) => {
  const [timeLeft, setTimeLeft] = useState<string>('')
  const [isExpired, setIsExpired] = useState(false)

  useEffect(() => {
    const calculateTimeLeft = () => {
      const now = Date.now() // Use Date.now() for consistency with PaymentConfirmationScreen
      const expiry = new Date(expiresAt).getTime()
      const diffInMs = expiry - now

      if (diffInMs <= 0) {
        if (!isExpired) {
          setTimeLeft('Quote expired')
          setIsExpired(true)
          // Notify parent component that quote has expired
          onExpired?.()
        }
        return
      }

      setIsExpired(false)
      const diffInSeconds = Math.floor(diffInMs / 1000)
      const minutes = Math.floor(diffInSeconds / 60)
      const seconds = diffInSeconds % 60

      // Remove the "~" for more precise timing
      if (minutes > 0) {
        setTimeLeft(`${minutes}m ${seconds}s remaining`)
      } else {
        setTimeLeft(`${seconds}s remaining`)
      }
    }

    // Calculate immediately
    calculateTimeLeft()

    // Update every second
    const interval = setInterval(calculateTimeLeft, 1000)

    return () => clearInterval(interval)
  }, [expiresAt, isExpired, onExpired])

  return (
    <span
      className={`${className} ${isExpired ? 'text-red-600 dark:text-red-300' : 'text-gray-900 dark:text-gray-100'}`}
    >
      {timeLeft}
    </span>
  )
}

export default QuoteTimer
